import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoginWeb from './LoginWeb';
import { isMobileViewport, MOBILE_LOGIN_PATH } from '../utils/authRoutes';

/**
 * Point d'entrée `/login` : redirige vers le parcours mobile sur petit écran,
 * sauf si `?web=1` force la connexion web classique.
 */
const LoginEntry = () => {
  const location = useLocation();
  const forceWeb = new URLSearchParams(location.search).get('web') === '1';

  if (!forceWeb && isMobileViewport()) {
    return <Navigate to={MOBILE_LOGIN_PATH} replace state={location.state} />;
  }

  return <LoginWeb />;
};

export default LoginEntry;
